import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

export const Container = styled.div`
  box-shadow: 0px 4px 4px rgba(192, 189, 189, 0.25);
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.white};
  transition: all 0.2s ease-in-out;
  &:hover {
    box-shadow: 0px 4px 4px rgba(192, 189, 189, 0.75);
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const Image = styled.img`
  width: 100%;
  height: 200px;
  @media screen and (max-width: 768px) {
    height: 240px;
  }
`

const label = css`
  font-size: 12px;
  line-height: 15px;
  font-family: ${({ theme }) => theme.fontFamily};
`

export const Label = styled(Link)`
  ${label};
  font-weight: bold;
  color: ${({ theme }) => theme.colors.orange};
  &::after {
    content: ' →';
  }
`

export const LabelDate = styled.p`
  ${label};
  font-weight: normal;
  color: ${({ theme }) => theme.colors.grey600};
`

export const Text = styled.p`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 14px;
  line-height: 17px;
  color: ${({ theme }) => theme.colors.grey600};
  margin: 16px 0 24px;
`

export const Title = styled.h2`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 20px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.black};
`
